module.exports = __webpack_public_path__ + "static/media/bazing-white-logo.80b8b670.png";